// src/components/OfferSection.tsx
import { motion } from 'framer-motion';
import FeatureCard from '@/components/FeatureCard';

interface FeatureProps {
  title: string;
  description: string;
  imageSrc: string;
  link: string;
}

interface OfferSectionProps {
  features: FeatureProps[];
}

const OfferSection = ({ features }: OfferSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {features.map((feature, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          style={{ transform: 'none !important' }}
          className="transform-none"
        >
          <FeatureCard 
            title={feature.title}
            description={feature.description}
            imageSrc={feature.imageSrc}
            link={feature.link}
          />
        </motion.div>
      ))}
    </div>
  );
};

export default OfferSection;